import axios from 'axios'
import jwt from 'jsonwebtoken'

export default {
  async query(mytoken, soql) {
    console.log('manda la query');
    var url = "./query";
    var payload = {
      token: mytoken,
      soql: soql,
    }
    
    console.log('apiclient query payload',payload);
    var jwtpayload = jwt.sign( payload, this.secret );

    let resp=await axios.post(url, { payload: jwtpayload } )

    console.log('ricevuto');
    return resp.data;
  },
  
  async create(mytoken, object, properties) {
    console.log('manda la create');
    var url = "./create";

    let data={};
    for (let p in properties) {
      if (p!='Id' && p!='attributes') data[p]=properties[p];
    }

    var payload = {
      token: mytoken,
      object: object,
      recordData: data,
    }
    console.log('create',payload);

    var jwtpayload = jwt.sign( payload, this.secret );

    let resp=await axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient.create error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })

    // console.log('ricevuto', resp.data);
    // console.log('ricevuto2', resp.data.data);
    return resp.data;
  },

  async retrieve(mytoken, object, recordId, properties, associations) {
    console.log('manda la retrieve');
    var url = "./retrieve";
    var payload = {
      token: mytoken,
      object: object,
      recordId: recordId,
      properties: properties,
      associations: associations
    }
    console.log('retrieve',payload);

    var jwtpayload = jwt.sign( payload, this.secret );

    let resp=await axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient.retrieve error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })

    // console.log('ricevuto', resp.data);
    // console.log('ricevuto2', resp.data.data);
    return resp.data;
  },


  async update(mytoken, object, recordId, properties) {
    console.log('manda la update');
    var url = "./update";

    let data={};
    for (let p in properties) {
      if (p!='Id' && p!='attributes' && typeof properties[p] != 'object') data[p]=properties[p];
    }

    var payload = {
      token: mytoken,
      object: object,
      recordId: recordId,
      recordData: data,
    }
    console.log('update',payload);

    var jwtpayload = jwt.sign( payload, this.secret );

    let resp=await axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient.update error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })
    // console.log('ricevuto', resp.data);
    // console.log('ricevuto2', resp.data.data);
    
    return resp.data;
  },

  async delete(mytoken, object, recordId) {
    console.log('manda la delete');
    var url = "./delete";

    var payload = {
      token: mytoken,
      object: object,
      recordId: recordId
    }
    console.log('delete',payload);

    var jwtpayload = jwt.sign( payload, this.secret );

    // const response = await axios.delete(url, config);
    let resp=await axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient.delete error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })
    // console.log('ricevuto', resp.data);
    // console.log('ricevuto2', resp.data.data);
    
    return resp.data;
  },
  
  async getcontentbody(connection_id, uri){
    console.log('apiclient getcontentbody entered');
    let url = "./getContentBody";
    let payload = { connection_id: connection_id, uri: uri };
    console.log('getcontentbody payload', payload);
    let jwtpayload = jwt.sign(payload, this.secret);
    let resp = await axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient getcontentbody error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })
    return resp;
  },

  createcontentversion(connection_id, data){
    console.log('apiclient createcontentversion entered');
    let url = "./createContentVersion";
    let payload = { connection_id: connection_id, data: data };
    console.log('createcontentversion payload', payload);
    let jwtpayload = jwt.sign(payload, this.secret);
    let resp = axios.post(url, { payload: jwtpayload } )
    .catch(function (error) {
      console.log('apiclient createcontentversion error', error.length, error)
      if (error.response) {
        return error.response
      } else if (error.request) console.log(error.request);
      else console.log('Error', error.message);
    })
    return resp;
  },

  // Funzione per convertire la chiave VAPID in Uint8Array
  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  },
  
  secret: '094bb161511fe289e2e3d0738a23635e32c62bea5cbe60da6d33328305bb1490'

}

